module.exports = __webpack_public_path__ + "static/media/zm.3eef5dc0.svg";